'use client';

import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Optional breadcrumb segments shown under the title */
  breadcrumbs?: string[];
  actions?: React.ReactNode;
}

const PageHeader = React.memo(function PageHeader({
  title,
  subtitle,
  breadcrumbs,
  actions,
}: PageHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-slate-800 dark:text-white">{title}</h1>
        {breadcrumbs && breadcrumbs.length > 0 ? (
          <div className="flex items-center gap-2 text-sm text-slate-500 mt-1 flex-wrap">
            <i className="ri-home-4-line text-xs" />
            {breadcrumbs.map((crumb, i) => (
              <React.Fragment key={`${crumb}-${i}`}>
                {i > 0 && <i className="ri-arrow-right-s-line text-[10px]" />}
                <span className={i === breadcrumbs.length - 1 ? 'text-slate-700 dark:text-slate-300 font-medium' : ''}>
                  {crumb}
                </span>
              </React.Fragment>
            ))}
          </div>
        ) : (
          subtitle && (
            <p className="text-sm mt-0.5 text-slate-500 dark:text-slate-400">{subtitle}</p>
          )
        )}
      </div>
      {actions && <div className="flex items-center gap-2 flex-shrink-0 flex-wrap">{actions}</div>}
    </div>
  );
});

export default PageHeader;
